// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconCopyRight = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '33',
      height: '33',
      viewBox: '0 0 33 33',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.5 18.047V7.125a3 3 0 0 0-3-3H13.578m5.672 24.75H9.969a3.094 3.094 0 0 1-3.094-3.094V12.375A3.094 3.094 0 0 1 9.969 9.28h9.281a3.094 3.094 0 0 1 3.094 3.094V25.78a3.094 3.094 0 0 1-3.094 3.094z',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round'
    })
  );

export { IconCopyRight };
